export const FETCH_LEADERBOARDS = 'FETCH_LEADERBOARDS';
export const CREATE_LEADERBOARD = 'CREATE_LEADERBOARD';
export const EDIT_LEADERBOARD = 'EDIT_LEADERBOARD';
export const DELETE_LEADERBOARD = 'DELETE_LEADERBOARD';
export const PUBLISH_LEADERBOARD = 'PUBLISH_LEADERBOARD';
